import "./ModalCadastro.css";
import { useState } from "react";
import axios from "axios";

export default function ModalCadastro({
  cadastro,
  onClose,
  onAtualizar
}) {

  const [dados, setDados] = useState(cadastro);
const [alteracoes, setAlteracoes] = useState({});
const [salvando, setSalvando] = useState(false);

function alterarCampo(campo, valor) {

  setDados((old) => ({
    ...old,
    [campo]: valor
  }));

  if (valor === cadastro[campo]) {

    setAlteracoes((old) => {
      const novo = { ...old };
      delete novo[campo];
      return novo;
    });

  } else {

    setAlteracoes((old) => ({
      ...old,
      [campo]: valor
    }));

  }

}

async function salvar() {

  if (Object.keys(alteracoes).length === 0) {
    return;
  }

  try {

    setSalvando(true);

    await axios.put(
      "https://app.eliandroalimentos.com.br/api/novocadastro/editar",
      {
        id: dados.id,
        ...alteracoes
      }
    );

    alert("Cadastro atualizado.");

    setDados((old) => ({
  ...old,
  ...alteracoes
}));

if (onAtualizar) {
  onAtualizar(
    dados.id,
    alteracoes
  );
}

setAlteracoes({});

  } catch (err) {

    console.error(err);

    alert("Erro ao salvar.");

  } finally {

    setSalvando(false);

  }

}

  function valor(campo) {
    if (
      campo === null ||
      campo === undefined ||
      campo === ""
    ) {
      return "-";
    }

    return campo;
  }

  function formatarData(data) {
    if (!data) return "-";

    const partes = data.split("-");

    if (partes.length !== 3) {
      return "-";
    }

    return `${partes[2]}/${partes[1]}/${partes[0]}`;
  }

  return (
  <div
    className="modalcadastro-overlay"
    onClick={onClose}
  >
    <div
      className="modalcadastro-container"
      onClick={(e) => e.stopPropagation()}
    >

      <div className="modalcadastro-header">

        <h2>Solicitação de Cadastro</h2>

        <button
          className="modalcadastro-fechar"
          onClick={onClose}
        >
          ✕
        </button>

      </div>

      <div className="modalcadastro-grid">

        <div className="modalcadastro-linha-2">

          <div>
            <strong>Nome Fantasia</strong>

            <input
              className="modalcadastro-input"
              value={dados.nomecliente || ""}
              onChange={(e) =>
                alterarCampo(
                  "nomecliente",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>Razão Social</strong>

            <input
              className="modalcadastro-input"
              value={dados.razaosocial || ""}
              onChange={(e) =>
                alterarCampo(
                  "razaosocial",
                  e.target.value
                )
              }
            />
          </div>

        </div>

        <div className="modalcadastro-linha-3">

          <div>
            <strong>CNPJ</strong>

            <input
              className="modalcadastro-input"
              value={dados.cgc || ""}
              onChange={(e) =>
                alterarCampo(
                  "cgc",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>CPF</strong>

            <input
              className="modalcadastro-input"
              value={dados.cpf || ""}
              onChange={(e) =>
                alterarCampo(
                  "cpf",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>Inscrição Estadual</strong>

            <input
              className="modalcadastro-input"
              value={dados.inscestadual || ""}
              onChange={(e) =>
                alterarCampo(
                  "inscestadual",
                  e.target.value
                )
              }
            />
          </div>

        </div>

        <div className="modalcadastro-linha-3">

          <div>
            <strong>Email</strong>

            <input
              className="modalcadastro-input"
              value={dados.email || ""}
              onChange={(e) =>
                alterarCampo(
                  "email",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>Telefone</strong>

            <input
              className="modalcadastro-input"
              value={dados.fone || ""}
              onChange={(e) =>
                alterarCampo(
                  "fone",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>Telefone 2</strong>

            <input
              className="modalcadastro-input"
              value={dados.fone2 || ""}
              onChange={(e) =>
                alterarCampo(
                  "fone2",
                  e.target.value
                )
              }
            />
          </div>

        </div>

        <div className="modalcadastro-linha-3">

          <div>
            <strong>Endereço</strong>

            <input
              className="modalcadastro-input"
              value={dados.endereco || ""}
              onChange={(e) =>
                alterarCampo(
                  "endereco",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>Número</strong>

            <input
              className="modalcadastro-input"
              value={dados.numero || ""}
              onChange={(e) =>
                alterarCampo(
                  "numero",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>Bairro</strong>

            <input
              className="modalcadastro-input"
              value={dados.bairro || ""}
              onChange={(e) =>
                alterarCampo(
                  "bairro",
                  e.target.value
                )
              }
            />
          </div>

        </div>

        <div className="modalcadastro-linha-3">

          <div>
            <strong>Cidade</strong>

            <input
              className="modalcadastro-input"
              value={dados.cidade || ""}
              onChange={(e) =>
                alterarCampo(
                  "cidade",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>Estado</strong>

            <input
              className="modalcadastro-input"
              value={dados.estado || ""}
              onChange={(e) =>
                alterarCampo(
                  "estado",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>CEP</strong>

            <input
              className="modalcadastro-input"
              value={dados.cep || ""}
              onChange={(e) =>
                alterarCampo(
                  "cep",
                  e.target.value
                )
              }
            />
          </div>

        </div>

        <div className="modalcadastro-linha-2">

          <div>
            <strong>Complemento</strong>

            <input
              className="modalcadastro-input"
              value={dados.complemento || ""}
              onChange={(e) =>
                alterarCampo(
                  "complemento",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>Ponto de Referência</strong>

            <input
              className="modalcadastro-input"
              value={dados.pontoref || ""}
              onChange={(e) =>
                alterarCampo(
                  "pontoref",
                  e.target.value
                )
              }
            />
          </div>

        </div>

        <div className="modalcadastro-linha-3">

          <div>
            <strong>Data Cadastro</strong>

            <input
              className="modalcadastro-input"
              value={formatarData(dados.dtcadastro)}
              readOnly
            />
          </div>

          <div>
            <strong>Novo</strong>

            <input
              className="modalcadastro-input"
              value={dados.novo || ""}
              onChange={(e) =>
                alterarCampo(
                  "novo",
                  e.target.value
                )
              }
            />
          </div>

          <div>
            <strong>Status</strong>

            <input
              className="modalcadastro-input"
              value={dados.status || ""}
              onChange={(e) =>
                alterarCampo(
                  "status",
                  e.target.value
                )
              }
            />
          </div>

        </div>

      </div>

      <div className="modalcadastro-observacao">

        <strong>Observação</strong>

        <textarea
          className="modalcadastro-textarea"
          value={dados.observacao || ""}
          onChange={(e) =>
            alterarCampo(
              "observacao",
              e.target.value
            )
          }
        />

      </div>

      {Object.keys(alteracoes).length > 0 && (

        <div className="modalcadastro-acoes">

          <button
            className="modalcadastro-btn-salvar"
            disabled={salvando}
            onClick={salvar}
          >
            {salvando
              ? "Salvando..."
              : "Salvar"}
          </button>

        </div>

      )}

    </div>
  </div>
);
}